<template>
<div class="chapter">
<div class="inner_page">
<h1>Mary</h1>
<h3 class="sigil_not_in_toc"><i>The Merry Widows, Book 1</i></h3>
<h3 class="sigil_not_in_toc">Raine Cantrell</h3>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_titlepage.vue?aaefe05c